import { Option } from '@/types'

export type ClientType = 'Pessoa Física' | 'Pessoa Jurídica' | 'Condomínio'

export const typeOptions: Array<ClientType> = ['Pessoa Física', 'Pessoa Jurídica', 'Condomínio']
export const stateOptions: Array<'SP' | 'MT' | 'MG' | 'DF' | 'GO' | 'TO'> = [
  'SP',
  'MT',
  'MG',
  'DF',
  'GO',
  'TO'
]

export const clientType: Array<Option> = [
  {
    value: 'Pessoa jurídica de direito privado',
    label: 'Pessoa jurídica de direito privado'
  },
  {
    value: 'Pessoa jurídica de direito público',
    label: 'Pessoa jurídica de direito público'
  }
]

export const UCGroupOptions: Array<Option> = [
  {
    value: 'AT',
    label: 'AT'
  },
  {
    value: 'BT',
    label: 'BT'
  }
]

export const UCSubGroupOptions: Array<Option> = [
  {
    value: 'B1',
    label: 'B1 Residencial'
  },
  {
    value: 'B2 Rural',
    label: 'B2 Rural'
  },
  {
    value: 'B3',
    label: 'B3 Comercial'
  }
]

export const tariffModalityOptions: Array<Option> = [
  {
    value: 'Azul',
    label: 'Azul'
  },
  {
    value: 'Branca',
    label: 'Branca'
  },
  {
    value: 'Convencional',
    label: 'Convencional'
  },
  {
    value: 'Convencional pré-pagamento',
    label: 'Convencional pré-pagamento'
  },
  {
    value: 'Distribuição',
    label: 'Distribuição'
  },
  {
    value: 'Energia suprimento',
    label: 'Energia suprimento'
  },
  {
    value: 'Geração',
    label: 'Geração'
  },
  {
    value: 'Verde',
    label: 'Verde'
  },
  {
    value: 'Tarifa Subsidiada',
    label: 'Tarifa Subsidiada'
  }
]

export type consorciosEstados = 'SP' | 'MT' | 'MG' | 'DF' | 'GO' | 'TO'

export type consorcioData = {
  nome?: string
  endereco?: string
  cnpj?: string
  desconto_padrao?: string
}

export const consorcios: Record<consorciosEstados, consorcioData> = {
  SP: {
    nome: 'CONSÓRCIO BC ENERGIA SP01',
    endereco: 'R. Funchal N° 441 Conj 34 Sala H, Vila Olimpia, São Paulo, SP, CEP 04.551-060',
    cnpj: '47.680.085/0001-60',
    desconto_padrao: '15%'
  },
  MT: {
    nome: 'CONSÓRCIO BC ENERGIA MT01',
    endereco:
      'A Rural Estrada 8, Sitios De Recreio Aguas Quentes, Chacara 17 Lote 02, Area Rural de Barra do Garças, Barra do Garças, MT, CEP 78.607-899',
    cnpj: '45.332.607/0001-07',
    desconto_padrao: '18%'
  },
  MG: {
    nome: 'CONSÓRCIO PAPANA',
    endereco:
      'Rod Vazante Lagamar Km 02, Fazenda Vazantes, Zona Rural, Vazante, MG, CEP 38.780-000',
    cnpj: '37.659.306/0001-64',
    desconto_padrao: '18%'
  },
  DF: {
    nome: 'CONSÓRCIO BC ENERGIA DF01',
    endereco: 'Q Sbs Quadra 2, Bloco Q Sala 905/907, Asa Sul, Brasília, DF, CEP 70.070-120',
    cnpj: '43.353.512/0001-44',
    desconto_padrao: '15%'
  },
  GO: {
    nome: 'CONSORCIO BC ENERGIA GO02',
    endereco:
      'Av Deputado Jamel Cecílio, N° 2929, Ed Brookfield Towers Bloco B Andar 28 Sl 03, Jardim Goias, Goiânia, GO, CEP 74.810-030',
    cnpj: '40.632.959/0001-64',
    desconto_padrao: '18%'
  },
  TO: {
    nome: 'BC ENERGIA TOO1',
    endereco:
      'Q Asr Se 15, Rua Sr 05, Conj 09, Lote 28 Sn Plano Diretor Sul CEP 77.020-174 Palmas - TO',
    cnpj: '40.632.964/0001-77',
    desconto_padrao: '18%'
  }
}

export const estados: Array<Option> = [
  { value: 'AC', label: 'AC' },
  { value: 'AL', label: 'AL' },
  { value: 'AP', label: 'AP' },
  { value: 'AM', label: 'AM' },
  { value: 'BA', label: 'BA' },
  { value: 'CE', label: 'CE' },
  { value: 'DF', label: 'DF' },
  { value: 'ES', label: 'ES' },
  { value: 'GO', label: 'GO' },
  { value: 'MA', label: 'MA' },
  { value: 'MT', label: 'MT' },
  { value: 'MS', label: 'MS' },
  { value: 'MG', label: 'MG' },
  { value: 'PA', label: 'PA' },
  { value: 'PB', label: 'PB' },
  { value: 'PR', label: 'PR' },
  { value: 'PE', label: 'PE' },
  { value: 'PI', label: 'PI' },
  { value: 'RJ', label: 'RJ' },
  { value: 'RN', label: 'RN' },
  { value: 'RS', label: 'RS' },
  { value: 'RO', label: 'RO' },
  { value: 'RR', label: 'RR' },
  { value: 'SC', label: 'SC' },
  { value: 'SP', label: 'SP' },
  { value: 'SE', label: 'SE' },
  { value: 'TO', label: 'TO' }
]

export const estadoCivil: Array<Option> = [
  { value: 'Solteiro(a)', label: 'Solteiro(a)' },
  { value: 'Casado(a)', label: 'Casado(a)' },
  { value: 'Separado(a)', label: 'Separado(a)' },
  { value: 'Divorciado(a)', label: 'Divorciado(a)' },
  { value: 'Viúvo(a)', label: 'Viúvo(a)' },
  { value: 'União Estável', label: 'União Estável' }
]
